import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import Datenschutz from "./pages/Datenschutz";
import Impressum from "./pages/Impressum";
import AGB from "./pages/AGB";
import DepotCheck from "./pages/DepotCheck";
import DankeBewerbung from "./pages/DankeBewerbung";
import Admin from "./pages/Admin";
import { Toaster } from "./components/ui/sonner";
import CookieBanner from "./components/CookieBanner";
import { SiteConfigProvider } from "./lib/siteConfig";

function App() {
  return (
    <div className="App">
      <SiteConfigProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/danke-bewerbung" element={<DankeBewerbung />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/depotcheck" element={<DepotCheck />} />
            <Route path="/depotcheck/bezahlt" element={<DepotCheck />} />
            <Route path="/depotcheck/start" element={<DepotCheck />} />
            <Route path="/depotcheck/test" element={<DepotCheck />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/agb" element={<AGB />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
        <CookieBanner />
      </SiteConfigProvider>
    </div>
  );
}

export default App;
